import { getEntity } from "./base";

const path = "/portal/api/clients/show_current";

const getClientData = (clientConfig) => {
  return getEntity(clientConfig, "", path);
};

export { getClientData };
